import { useCaptivePortalContext } from "@givelify/onboarding";
import { Navigate, Outlet } from "react-router-dom";
import { PATH } from "./routes";

export const CaptivePortalGuard = () => {
    const { showCaptivePortal } = useCaptivePortalContext();
    return showCaptivePortal ? (
        <Navigate replace to={PATH.OVERVIEW} />
    ) : (
        <Outlet />
    );
};